import React, { useRef, useEffect, useState } from "react";




const Matrix = ({ height, data, which }) => {
    const containerRef = useRef(null);
    const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });



    useEffect(() => {
        if (containerRef.current) {
            setContainerSize({
                width: containerRef.current.offsetWidth,
                height: containerRef.current.offsetHeight,
            });
        }
    }, []);

  /*  let remote_data_dummy = [{
        impact_category: 2,
        probability: 3,
        risk_count: 1,
        risk_level: 2
    }]
*/
    const convertDummyDataToPoints = (dummyData) => {
        return dummyData && dummyData.map(item => ({
            x: item.impact_category + 0,
            y: item.probability + 0,
            value: item.risk_count
        }));
    };

    //////console.log(which, data);
    const countRiskLevels = (data) => {
        const riskLevels = {
            low: 0,
            moderate: 0,
            high: 0,
            extreme: 0
        };

        ////console.log("MATRIX: ", data)

        data && data.forEach(item => {
            switch (item.risk_level) {
                case 0:
                    riskLevels.low += item.risk_count;
                    break;
                case 1:
                    riskLevels.moderate += item.risk_count;
                    break;
                case 2:
                    riskLevels.high += item.risk_count;
                    break;
                case 3:
                    riskLevels.extreme += item.risk_count;
                    break;
                default:
                    break;
            }
        });

        return riskLevels;
    };

    const riskLevels = countRiskLevels(data);

    const points = convertDummyDataToPoints(data);

    const getColor = (x, y) => {
        // Custom color pattern based on the screenshot
        const colors = [
            ["bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#F07167]", "bg-[#F07167]", "bg-[#F07167]"],
            ["bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#FED4AE]", "bg-[#F07167]", "bg-[#F07167]"],
            ["bg-[#09A6B0]", "bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#FED4AE]", "bg-[#F07167]"],
            ["bg-[#05769D]", "bg-[#09A6B0]", "bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#FED4AE]"],
            ["bg-[#05769D]", "bg-[#05769D]", "bg-[#09A6B0]", "bg-[#09A6B0]", "bg-[#FED4AE]"]
        ];
        return colors[y][x];
    };

    /*const lineCoordinates = points && points.map(({ x, y }) => {
        const xOffset = (x + 1) * (containerSize.width / 5);
        const yOffset = (y + 1) * (containerSize.height / 5);
        return { x: xOffset, y: yOffset };
    });*/
    ////console.log("riskLevels: ", riskLevels);
    return (
        <div ref={containerRef} className="w-full flex flex-col items-center justify-center overflow-hidden relative h-full p-2" style={{ height }}>
            {/* Legend positioned above the grid */}
            {/*<div className="flex justify-center items-center gap-1 flex-nowrap mt-2">
                <span className="badge bg-[#05769D] items-center p-1 px-2 rounded-[5px] text-white text-ellipsis m-0 whitespace-nowrap">
                   2 Low
                </span>
                <span className="badge bg-[#09A6B0] items-center p-1 px-2 rounded-[5px] text-white text-ellipsis m-0 whitespace-nowrap">
                    0 Moderate
                </span>
                <span className="badge bg-[#FED4AE] items-center p-1 px-2 rounded-[5px] text-black text-ellipsis m-0 whitespace-nowrap">
                    12 High
                </span>
                <span className="badge bg-[#F07167] items-center p-1 px-2 rounded-[5px] text-black text-ellipsis m-0 whitespace-nowrap">
                   20 Extreme
                </span>
            </div>*/}


            <div className="flex justify-center items-center gap-1 flex-nowrap mt-2">


                {Object.entries(riskLevels).map(([level, count]) => (
                    <div
                        className={`flex items-center justify-center rounded-md ${level === "low" ? "bg-[#05769D]" : level === "moderate" ? "bg-[#09A6B0]" : level === "high" ? "bg-[#FED4AE]" : "bg-[#F07167]"}`}
                        style={{
                            height: `${containerSize.height / 6 - 10}px`,
                        }}
                    >
                        <div className="flex items-center justify-center text-white z-10 p-2">
                            <span className="text-xs md:text-sm lg:text-base">{count} {level.charAt(0).toUpperCase() + level.slice(1)}</span>
                        </div>

                    </div>

                ))}



            </div>

            <div className="grid grid-rows-5 grid-cols-5 gap-1 w-full h-full p-2">
                {/* Rows with Y-Axis Labels and Grid Blocks */}
                {["Almost Certain", "Likely", "Possible", "Unlikely", "Rare"].map((likelihood, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                        {/* Grid Blocks */}
                        {[...Array(5)].map((_, colIndex) => (
                            <div
                                key={`${rowIndex}-${colIndex}`}
                                className={`flex items-center justify-center rounded-md ${getColor(colIndex, rowIndex)}`}
                                style={{
                                    height: `${containerSize.height / 6 - 10}px`,
                                }}
                            >
                                {points && points.find((point) => point.x === colIndex && point.y === 4 - rowIndex) && (
                                    <div className="flex items-center justify-center text-white z-10">
                                        {points.find((point) => point.x === colIndex && point.y === 4 - rowIndex).value}
                                    </div>
                                )}
                            </div>
                        ))}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default Matrix;
